import request from "@/utils/request";
import Cookies from "js-cookie";

// 菜单
export function getMenu(params) {
  return request({
    url: "/jeecg-boot/index/menu",
    method: "GET",
    params: params,
  });
}

// banner
export function getBanner(params) {
  return request({
    url: "/jeecg-boot/index/banner",
    method: "GET",
    params: params,
  });
}

// 获取首页信息
export function getInfo(params) {
  return request({
    url: "/jeecg-boot/index/info",
    method: "GET",
    params: params,
  });
}

// 首页信息新闻列表查询
export function getArticleDes(params) {
  return request({
    url: "/jeecg-boot/index/articleDes",
    method: "GET",
    params: params,
  });
}

// 首页轮播图片查询
export function getArticleDesSylbApi(params) {
  return request({
    url: "/jeecg-boot/index/v9NewsSylbList",
    method: "GET",
    params: params,
  });
}

// 文章类-分页列表查询（党建信息，行业要闻，工程交易）
export function getArticle(params) {
  return request({
    url: "/jeecg-boot/index/article",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}

// 文章详情查询
export function getDetatilArticle(params) {
  return request({
    url: "/jeecg-boot/index/detatilArticle",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}
// 文章详情 获取微信二维码
export function getArticleQr(params) {
  return request({
    url: "/jeecg-boot/index/articleQr",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}

// 首页会员单位
export function getVip(params) {
  return request({
    url: "/jeecg-boot/index/vip",
    method: "GET",
    params: params,
  });
}

// 首页会员单位
export function getVipInfo(params) {
  return request({
    url: "/jeecg-boot/index/vipInfo",
    method: "GET",
    params: params,
  });
}

// 首页外部链接
export function getLinks(params) {
  return request({
    url: "/jeecg-boot/index/links",
    method: "GET",
    params: params,
  });
}

// 首页飘窗
export function getPcList(params) {
  return request({
    url: "/jeecg-boot/index/getPcList",
    method: "GET",
    params: params,
  });
}

// 首页友情链接
export function getPartner(params) {
  return request({
    url: "/jeecg-boot/index/partner",
    method: "GET",
    params: params,
  });
}

// 首页政策法规关键词
export function getLawKw(params) {
  return request({
    url: "/jeecg-boot/index/lawKw",
    method: "GET",
    params: params,
  });
}

// 【从业人员】
export function getCyry(params) {
  return request({
    url: "/jeecg-boot/index/cyry",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 【从业人员-在线教育学习记录】
export function getStudyRecordsApi(params) {
  return request({
    url: "/jeecg-boot//index/studyRecords",
    method: "GET",
    params: {
      ...params,
    },
  });
}
// 【从业人员-/companyCyrys】
export function getCompanyCyrys(params) {
  return request({
    url: "/jeecg-boot/index/companyCyrys",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 【从业人员-/companyCyrys】个人端
export function getCompanyCyrysGr(params) {
  return request({
    url: "/jeecg-boot/index/companyCyrys",
    method: "GET",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
      ...params,
    },
  });
}

//中标地区获取
export function getZbdq(params) {
  return request({
    url: "/jeecg-boot/index/zbdq",
    method: "GET",
    params: params,
  });
}

// 会员名单
export function getVipList(params) {
  return request({
    url: "/jeecg-boot/management.student/tSocietyStudent/list",
    method: "GET",
    params: params,
  });
}

// 会员证书是否有效
export function checkVipPeriod(params) {
  return request({
    url: "/jeecg-boot/index/checkVipPeriod",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}

// 会议
export function getMeeting(params) {
  return request({
    url: "/jeecg-boot/vip/meeting",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}

// 会费
export function getJkxx(params) {
  return request({
    url: "/jeecg-boot/vip/jkxx",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}

// 基本信息
export function queryVipInfo(params) {
  return request({
    url: "/jeecg-boot/vip/queryVipInfo",
    method: "GET",
    params: {
      ...params,
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}

// 【从业人员】
export function getXmfzr(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr",
    method: "GET",
    params: {
      ...params,
    },
  });
}

// 企业-评优-信用评价 企业端-信用评价-获取可申报的模板
export function getDeclareTemplateApi(params) {
  return request({
    url: "/jeecg-boot/index/getDeclareTemplate",
    method: "GET",
    params: {
      ...params,
    },
  });
}
// 企业-评优-信用评价 企业端-信用评价-获取可申报的模板
export function getDownloadFileApi(params) {
  return request({
    url: "/jeecg-boot/index/links",
    method: "GET",
    params: {
      ...params,
    },
  });
}

// 企业端-信用评价-单位申报记录
export function getDeclareRecordApi(params) {
  return request({
    url: "/jeecg-boot/index/getDeclareRecord",
    method: "GET",
    params: {
      ...params,
    },
  });
}
// 企业端-信用评价-模版内容树结构
export function getTreeTemplateContetsApi(params) {
  return request({
    url: "/jeecg-boot/index/treeTemplateContets",
    method: "GET",
    params: {
      ...params,
    },
  });
}

// 企业端-信用评价-单位申报保存
export function saveDeclareRecordApi(params) {
  return request({
    url: "/jeecg-boot/index/saveDeclareRecord",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}

// 企业端-信用评价-单位申报记录详情
export function getDeclareRecordDetailsApi(params) {
  return request({
    url: "/jeecg-boot/index/getDeclareRecordDetails",
    method: "GET",
    params: {
      ...params,
    },
  });
}

// 企业端-信用评价-单位申报详情修改
export function batchEditDeclareDetailApi(params) {
  return request({
    url: "/jeecg-boot/index/batchEditDeclareDetail",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}

// 企业端-信用评价-补充材料修改
export function batchComplatementFileApi(params) {
  return request({
    url: "/jeecg-boot/index/batchComplatementFile",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}

// 企业端-信用评价-评审进度
export function getReviewLogListApi(params) {
  return request({
    url: "/jeecg-boot/index/reviewLogList",
    method: "GET",
    params: {
      ...params,
    },
  });
}
// 企业端- 企业端-项目负责人-评审进度-查询
export function getReviewLogListXmfzrApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/reviewLogList",
    method: "GET",
    params: {
      ...params,
    },
  });
}

// 企业端-信用评价-查看文件列表
export function getFilesByDetailid(params) {
  return request({
    url: "/jeecg-boot/index/getFilesByDetailid",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}

// 企业端-信用评价-查看文件列表
export function deleteFile(params) {
  return request({
    url: "/jeecg-boot/index/deleteFile",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 企业端-从业人员-新增从业人员
export function cyryAddApi(params) {
  return request({
    url: "/jeecg-boot/vip/cyryAdd",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}
// 企业端-从业人员-获取新增的从业人员列表
export function cyryReviewListApi(params) {
  return request({
    url: "/jeecg-boot/vip/cyryReviewList",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 企业端-从业人员-修改审核不通过从业人员
export function cyryUpdateApi(params) {
  return request({
    url: "/jeecg-boot/vip/cyryUpdate",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}
// 企业端-人员情况-项目负责人 企业申报保存
export function saveDeclareRecordByDwApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/saveDeclareRecordByDw",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}

// 企业端-个人端-项目负责人-个人申报保存
export function saveDeclareRecordByUserApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/saveDeclareRecordByUser",
    method: "POST",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}
// 企业端-人员情况-项目负责人-获取可申报的模板
export function getXmfzrDeclareTemplateApi() {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareTemplate",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
  });
}
// 个人端- 项目负责人申报-获取可申报的模板
export function getXmfzrDeclareTemplateCyryApi() {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareTemplate",
    method: "GET",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
    },
  });
}
// 企业端-项目负责人-获取单位申报记录
export function getDeclareRecordByDwApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareRecordByDw",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 企业端-个人端-项目负责人-获取个人申报记录
export function getDeclareRecordByUserApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareRecordByUser",
    method: "GET",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
      ...params,
    },
  });
}
// 企业端-项目负责人-申报记录详情
export function getXmfzrDeclareRecordDetailsApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareRecordDetails",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 个人端-项目负责人-申报记录详情
export function getXmfzrDeclareRecordDetailsCyryApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/getDeclareRecordDetails",
    method: "GET",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
      ...params,
    },
  });
}
// 企业端-项目负责人-申报详情修改
export function batchEditDeclareDetailXmfzrApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/batchEditDeclareDetail",
    method: "POST",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}
// 个人端-项目负责人-申报详情修改
export function batchEditDeclareDetailXmfzrCyryApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/batchEditDeclareDetail",
    method: "POST",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
    },
    data: {
      ...params,
    },
  });
}
// 企业端-项目负责人-申报记录删除
export function deleteDeclareAndDetailApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/deleteDeclareAndDetail",
    method: "GET",
    params: {
      token: Cookies.get("xh_userInfo")
        ? JSON.parse(Cookies.get("xh_userInfo")).token
        : "",
      ...params,
    },
  });
}
// 个人端-项目负责人-申报记录删除
export function deleteDeclareAndDetailCyryApi(params) {
  return request({
    url: "/jeecg-boot/index/xmfzr/deleteDeclareAndDetail",
    method: "GET",
    params: {
      token: Cookies.get("cyry_user")
        ? JSON.parse(Cookies.get("cyry_user")).token
        : "",
      ...params,
    },
  });
}
